var _linearGradient, _clipPath, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123,
    height: 20,
    role: "img",
    "aria-label": "adobe photoshop",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "adobe photoshop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 123,
    height: 20,
    fill: "#31a8ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPkFkb2JlIFBob3Rvc2hvcDwvdGl0bGU+PHBhdGggZD0iTTkuODUgOC40MmMtLjM3LS4xNS0uNzctLjIxLTEuMTgtLjItLjI2IDAtLjQ5IDAtLjY4LjAxLS4yLS4wMS0uMzQgMC0uNDEuMDF2My4zNmMuMTQuMDEuMjcuMDIuMzkuMDJoLjUzYy4zOSAwIC43OC0uMDYgMS4xNS0uMTguMzItLjA5LjYtLjI4LjgyLS41My4yMS0uMjUuMzEtLjU5LjMxLTEuMDMuMDEtLjMxLS4wNy0uNjItLjIzLS44OS0uMTctLjI2LS40MS0uNDYtLjctLjU3ek0xOS43NS4zSDQuMjVDMS45LjMgMCAyLjIgMCA0LjU1djE0Ljg5OWMwIDIuMzUgMS45IDQuMjUgNC4yNSA0LjI1aDE1LjVjMi4zNSAwIDQuMjUtMS45IDQuMjUtNC4yNVY0LjU1QzI0IDIuMiAyMi4xLjMgMTkuNzUuM3ptLTcuMzkxIDExLjY1Yy0uMzk5LjU2LS45NTkuOTgtMS42MDkgMS4yMi0uNjguMjUtMS40My4zNC0yLjI1LjM0LS4yNCAwLS40IDAtLjUtLjAxcy0uMjQtLjAxLS40My0uMDF2My4yMDljLjAxLjA3LS4wNC4xMzEtLjExLjE0MUg1LjUyYy0uMDggMC0uMTItLjA0MS0uMTItLjEzMVY2LjQyYzAtLjA3LjAzLS4xMS4xLS4xMS4xNyAwIC4zMyAwIC41Ni0uMDEuMjQtLjAxLjQ5LS4wMS43Ni0uMDJzLjU2LS4wMS44Ny0uMDJjLjMxLS4wMS42MS0uMDEuOTEtLjAxLjgyIDAgMS41LjEgMi4wNi4zMS41LjE3Ljk2LjQ1IDEuMzQuODIuMzIuMzIuNTcuNzEuNzMgMS4xNC4xNDkuNDIuMjI5Ljg1LjIyOSAxLjMuMDAxLjg2LS4xOTkgMS41Ny0uNiAyLjEzem03LjA5MSAzLjg5Yy0uMjguNC0uNjcxLjcwOS0xLjEyLjg5MS0uNDkuMjA5LTEuMDkuMzE4LTEuODExLjMxOC0uNDU5IDAtLjkxLS4wMzktMS4zNTktLjEyOS0uMzUtLjA2MS0uNy0uMTctMS4wMi0uMzItLjA3LS4wMzktLjEyMS0uMTA5LS4xMTEtLjE4OXYtMS43NGMwLS4wMjkuMDExLS4wNy4wNDEtLjA5LjAyOS0uMDIuMDYtLjAxLjA5LjAxLjM5LjIzLjguMzkxIDEuMjQuNDkuMzc5LjEuNzc5LjE1IDEuMTguMTUuMzggMCAuNjUtLjA1MS44My0uMTQxLjE2LS4wNy4yNy0uMjQuMjctLjQyIDAtLjE0MS0uMDgtLjI3LS4yNC0uNC0uMTYtLjEyOS0uNDg5LS4yNzktLjk3OS0uNDcxLS41MS0uMTgtLjk3OS0uNDItMS40Mi0uNzE5LS4zMS0uMjIxLS41NjktLjUxLS43NjEtLjg1LS4xNTktLjMyLS4yMzktLjY3LS4yMjktMS4wMjEgMC0uNDMuMTItLjg0LjM0MS0xLjIxLjI1LS40LjYxOS0uNzIgMS4wNDktLjkyLjQ2OS0uMjM5IDEuMDU5LS4zNDkgMS43NjktLjM0OS40MSAwIC44My4wMyAxLjI0LjA5LjMuMDQuNTkuMTIuODYuMjMuMDM5LjAxLjA4LjA1LjEuMDkuMDEuMDQuMDIuMDguMDIuMTJ2MS42M2MwIC4wNC0uMDIuMDgtLjA1LjEtLjA5LjAyLS4xNC4wMi0uMTggMC0uMy0uMTYtLjYyLS4yNy0uOTYtLjM0LS4zNy0uMDgtLjc0LS4xMy0xLjEyLS4xMy0uMi0uMDEtLjQxLjAyLS42MDEuMDctLjEyOS4wMy0uMjQuMS0uMzEuMi0uMDUuMDgtLjA4LjE4LS4wOC4yN3MuMDQuMTguMTAxLjI2Yy4wOS4xMS4yMDkuMi4zNC4yNy4yMjkuMTIuNDcuMjMuNzA5LjMzLjU0MS4xOCAxLjA2MS40MyAxLjU0MS43My4zMy4yMDkuNi40OS43ODkuODMuMTYuMzE4LjI0LjY3LjIzIDEuMDI5LjAxMS40NzEtLjEyOS45NC0uMzg5IDEuMzMxeiIvPjwvc3ZnPg=="
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 705,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 950
  }, "adobe photoshop"), /*#__PURE__*/React.createElement("text", {
    x: 705,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 950
  }, "adobe photoshop"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoshop);
export default __webpack_public_path__ + "static/media/photoshop.b153608043e5319278ceab52692c512c.svg";
export { ForwardRef as ReactComponent };